// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var AddMember = function AddMember(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("ellipse", {
      cx: "6.965",
      cy: "4.923",
      rx: "2.907",
      ry: "3.224"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.87 6.469h-1.318V5.151a.513.513 0 10-1.025 0v1.318h-1.318a.513.513 0 000 1.026h1.318v1.317a.513.513 0 101.025 0V7.5h1.318a.513.513 0 100-1.026zM6.965 8.934C3.68 8.934.975 11.02.621 13.7c-.043.324.287.6.674.6h11.34c.387 0 .716-.275.674-.6-.355-2.68-3.06-4.766-6.344-4.766z"
    }))
  );
};

export default AddMember;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/AddMember.js
// module id = 980
// module chunks = 0